import { render } from "./BatchPinCodes.vue?vue&type=template&id=c92476a0"
import script from "./BatchPinCodes.vue?vue&type=script&lang=js"
export * from "./BatchPinCodes.vue?vue&type=script&lang=js"
script.render = render

export default script